import { MatMenuModule, MenuPositionX } from '@angular/material/menu';
import { Component, input, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-tooltip',
  standalone: true,
  imports: [MatMenuModule],
  templateUrl: './tooltip.component.html',
  styleUrl: './tooltip.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class TooltipComponent {
  xPosition = input<MenuPositionX>('before');
  @Input() hover: boolean = false;
}
